var exports = {
  "qS": "SettingsStatusBadge.module__badge___SnNMV0",
  "Hl": "SettingsStatusBadge.module__new___SnNMV0",
  "ny": "SettingsStatusBadge.module__experimental___SnNMV0",
  "jp": "SettingsStatusBadge.module__badges___SnNMV0",
};

module.exports = exports;
